/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function PrivateRoute({
   element: Element,
   isClosed,
   requiredPermissions,
   // eslint-disable-next-line no-unused-vars
   ...rest
}) {
   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
   const permissions = useSelector((state) => state.auth.permissions || []);
   const location = useLocation();

   // 1) Rota fechada e não logado
   if (isClosed && !isLoggedIn) {
      const prevPath = location.pathname;
      return <Navigate to="/login" replace state={{ prevPath }} />;
   }

   // 2) Logado, mas sem permissão (RBAC)
   function toArray(value) {
      if (Array.isArray(value)) return value;
      if (value) return [value];
      return [];
   }

   const req = toArray(requiredPermissions);

   if (isClosed && req.length > 0) {
      const hasAll = req.every((p) => permissions.includes(p));
      if (!hasAll) {
         return (
            <Navigate
               to="/403"
               replace
               state={{ prevPath: location.pathname, missing: req }}
            />
         );
      }
   }

   // 3) Se tentar /login logado, manda pra home
   if (!isClosed && isLoggedIn && location.pathname === '/login') {
      return <Navigate to="/main" replace />;
   }

   return Element;
}

PrivateRoute.propTypes = {
   element: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
   isClosed: PropTypes.bool,
   requiredPermissions: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
   ]),
};
